import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { RoleProtectedRoute } from '../../router/RoleProtectedRoute';
import { UserRole } from '../authentication/types';
import { SurveyAuditPage } from './pages/SurveyAuditPage';
import { SurveyAuditListPage } from './pages/SurveyAuditListPage';

export const SurveyAuditRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Audit List Page - Protected by role */}
      <Route
        path=""
        element={
          <RoleProtectedRoute requiredRoles={[UserRole.PROFESSOR, UserRole.COURSE_REPRESENTATIVE]}>
            <SurveyAuditListPage />
          </RoleProtectedRoute>
        }
      />

      {/* Audit Detail Page - Protected by role */}
      <Route
        path=":auditId"
        element={
          <RoleProtectedRoute requiredRoles={[UserRole.PROFESSOR, UserRole.COURSE_REPRESENTATIVE]}>
            <SurveyAuditPage />
          </RoleProtectedRoute>
        }
      />
    </Routes>
  );
};
